"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useSyncExternalStore } from "react";
const EDGE_OFFSET = 24; // px from viewport edge

interface DraggablePosition {
  /** Always bottom-right */
  readonly corner: "bottom-right";
  /** CSS style for positioning */
  readonly style: React.CSSProperties;
  /** No-op drag end handler (corner snapping removed) */
  readonly onDragEnd: (event: MouseEvent | TouchEvent | PointerEvent, info: {
    point: {
      x: number;
      y: number;
    };
  }) => void;
  /** Whether drag is enabled (disabled on mobile) */
  readonly isDragEnabled: boolean;
}
const BOTTOM_RIGHT_STYLE: React.CSSProperties = {
  bottom: EDGE_OFFSET,
  right: EDGE_OFFSET,
  top: "auto",
  left: "auto"
};
function subscribeToResize(onChange: () => void): () => void {
  window.addEventListener("resize", onChange);
  return () => window.removeEventListener("resize", onChange);
}
const readIsDragEnabled = () => window.innerWidth >= 768;
const readIsDragEnabledOnServer = () => false;

/**
 * Manages draggable FAB position — locked to bottom-right.
 * Drag is enabled on desktop for grab cursor affordance but no longer snaps to corners.
 */
export function useDraggablePosition() {
  const $ = _c(2);
  const isDragEnabled = useSyncExternalStore(subscribeToResize, readIsDragEnabled, readIsDragEnabledOnServer);
  const onDragEnd = _temp;
  let t0;
  if ($[0] !== isDragEnabled) {
    t0 = {
      corner: "bottom-right",
      style: BOTTOM_RIGHT_STYLE,
      onDragEnd,
      isDragEnabled
    };
    $[0] = isDragEnabled;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
function _temp(_event, _info) {}